var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlackhealth(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.34527 6.00998L8.50954 6.66048L8.20464 7.20627L7.04036 6.55577L7.34527 6.00998ZM5.50553 5.69857L6.66981 6.34907L6.97472 5.80328L5.81044 5.15278L5.50553 5.69857ZM1.45933 6.66048L1.76424 7.20627L2.92798 6.55577L2.62307 6.00998L1.45933 6.66048ZM4.15791 5.15278L2.99362 5.80328L3.29852 6.34907L4.46278 5.69857L4.15791 5.15278ZM5.31241 4.13173V2.85352H4.68741V4.13173H5.31241ZM5.31241 1.13151H4.68741V2.40918H5.31241V1.13151ZM9.38848 2.48242V7.51823L4.99989 9.96941L0.611328 7.51823V2.48242L4.99989 0.03125L9.38848 2.48242ZM4.99989 0.7474L1.56479 2.66573L4.99989 4.58422L8.43498 2.66571L4.99989 0.7474ZM1.23633 7.15148L4.68738 9.07873V5.12579L1.23633 3.19837V7.15148ZM8.76345 7.15148V3.19837L5.31238 5.12579V9.07873L8.76345 7.15148Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackhealth);
export default __webpack_public_path__ + "static/media/blackhealth.cd5faabadbdc01bd922c3c5992b1f953.svg";
export { ForwardRef as ReactComponent };